import { ExtrudeGeometry, LatheGeometry, Shape, Vector2 } from 'three'
import type { Ponto2 } from './contornos2d'

/**
 * Extrusão de um contorno, centrada em z, com chanfro **para dentro**
 * (`bevelOffset` negativo): o contorno desenhado continua sendo a silhueta
 * final. Com o chanfro para fora, peças desenhadas encostadas (os braços
 * fechados do alargador, as lâminas do cortador) se invadiriam.
 */
export function extrusao(pontos: readonly Ponto2[], espessura: number, chanfro: number, segmentos: number) {
  const geometria = new ExtrudeGeometry(new Shape(pontos.map(([x, y]) => new Vector2(x, y))), {
    depth: espessura,
    bevelEnabled: chanfro > 0,
    bevelThickness: chanfro,
    bevelSize: chanfro,
    bevelOffset: -chanfro,
    bevelSegments: segmentos,
    curveSegments: 1,
  })
  geometria.translate(0, 0, -espessura / 2)
  return geometria
}

/**
 * Corpo torneado ao longo de x. `perfil` é uma lista de `[x, raio]` em x
 * crescente (de trás para a frente); o torno do three gira em torno de y, e a
 * rotação final deita a peça no eixo da ferramenta.
 */
export function torno(perfil: readonly Ponto2[], segmentos: number) {
  const geometria = new LatheGeometry(
    perfil.map(([x, raio]) => new Vector2(raio, x)),
    segmentos,
  )
  geometria.rotateZ(-Math.PI / 2)
  return geometria
}

/**
 * Anéis de pega para um perfil de torno: `n` cristas de `altura` sobre o raio
 * base, entre `x0` e `x1` (x crescente). Devolve só os pontos intermediários.
 */
export function aneisDePega(x0: number, x1: number, raio: number, altura: number, n: number): Ponto2[] {
  const pontos: Ponto2[] = []
  const passo = (x1 - x0) / n
  for (let i = 0; i < n; i++) {
    const x = x0 + i * passo
    pontos.push([x + passo * 0.2, raio], [x + passo * 0.35, raio + altura], [x + passo * 0.65, raio + altura], [x + passo * 0.8, raio])
  }
  return pontos
}
